<template>
  <div class="circle-container">
    <!-- Outer Circle -->
    <div class="outer-circle">
      <!-- Inner Circle with Text -->
      <div class="inner-circle">
        <div class="font-weight-bold">
          <div class="justify-gpa-center" style="font-size: 20px">{{ gpa }}</div>
          <div class="justify-gpa-center" style="font-size: 12px; color: #484848">GPA</div>
        </div>
        <img class="check-icon" style="width: 20px" :src="circleCheckGreenIcon" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import circleCheckGreenIcon from '@/assets/icons/circle-check-green.svg';

export default defineComponent({
  name: 'MyCollegeCreditsGpaCircle',

  props: {
    gpa: {
      type: String,
      default: '0'
    }
  },

  data() {
    return {
      circleCheckGreenIcon
    };
  }
});
</script>

<style scoped>
.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.outer-circle {
  width: 100%;
  height: 100%;
  border: 3px solid #498500;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.inner-circle {
  width: 90%;
  height: 90%;
  background-color: #f5f5f5;
  border: 1px solid #e6e6e6;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.check-icon {
  /* Position of circle check icon */
  position: absolute;
  left: 92%;
}
.justify-gpa-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
